import React, { useEffect, useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Images from 'assets/images'; // Make sure Images is imported
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    // Scroll handler
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > window.innerHeight);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // initialize on mount

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <div>
      <Header />
      <Outlet />
      <Footer />
      {showScrollTop && (
        <button
          type="button"
          className="scroll-to-top"
          aria-label="Scroll to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <img src={Images.scrolltop} alt="Scroll to top" />
        </button>
      )}
    </div>
  );
};

export default MainLayout;
